/**
 * Panel Body Component Index
 *
 * Export panel body component and types
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

export { PanelBody } from './component';
export type { PanelBodyProps } from './types';
